import Marionette from 'marionette'
import Backbone from 'backbone'
import ModalRegion from '../../components/modal/modalRegion.js'

import App from 'app'

module.exports = Marionette.View.extend({
  el: '.application',
  template: require('./templates/layout.html'),
  regions: {
    applicationRegion: '.application__region',
    mainRegion: '.main__region',
    menuRegion: '.menu__region',
    headerRegion: '.header__region',
    navigationRegion: '.navigation__region',

    // dialogRegion: '.dialog__region'
    dialogRegion: ModalRegion.extend({el: '#dialog'})
  },
  events: {
    'click .js-navigation-toggle': 'onNavigationToggleClick',
    'click': 'onPageClick'
  },
  onPageClick: function (e) {
    App.globalChannel.trigger('navigation:hide')
  },
  onNavigationToggleClick: function (e) {
    e.stopPropagation()
    App.globalChannel.trigger('navigation:toggle')
  },
  onBeforeShow: function () {}

})



// WEBPACK FOOTER //
// ./js/components/app-layout/index.js